import styles from './ScreenAudioConsentBar.module.css';

interface Props {
  onConsent: () => void;
}

/**
 * Maxischermo: un solo gesto (clic) per soddisfare la policy autoplay del browser.
 */
export default function ScreenAudioConsentBar({ onConsent }: Props) {
  return (
    <div className={styles.shell} role="region" aria-label="Attiva audio maxischermo">
      <button type="button" className={styles.btn} onClick={onConsent}>
        Attiva audio
      </button>
    </div>
  );
}
